import React, { useEffect, useState } from "react";
import {
  AddPaymentMenuIcon,
  BackIcon,
  BalanceSheetMenuIcon,
  DashboardMenuIcon,
  LeftArrowIcon,
  ReportsMenuIcon,
  SaleMenuIcon,
  ToggleIcon,
  UpdateBalanceMenuIcon,
  ViewPaymentMenuIcon,
} from "../../assets/svg";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

function SideBar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isDashboardPage, setIsDashboardPage] = useState(true);
  const { username, image } = useSelector((state) => state.auth);
  const location = useLocation();
  const defaultProfileImg = "https://placehold.co/600x400?text=Admin";

  useEffect(() => {
    const handleResize = () => {
      setIsCollapsed(window.innerWidth < 1399);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Check if the current URL is exactly "/dashboard"
    if (location.pathname !== "/dashboard") {
      setIsDashboardPage(false);
    } else {
      setIsDashboardPage(true);
    }
  }, [location.pathname]);

  return (
    <>
     <div className={`sideBarContainerBox placedHolder ${isCollapsed && "collapsed"}`} style={{opacity:'0'}}></div>
      <div className={`sideBarContainerBox ${isCollapsed && "collapsed"}`} style={{position:'fixed'}}>
        <div
          className="sideBarCollapseBtn"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <LeftArrowIcon />{" "}
        </div>

        <div className="siteLogo">
          <div className="mainLogo openMenu">Fresh Fruit</div>
          <div className="collapsedMenu mainLogo">F</div>
        </div>

        <div className={`menuItems  ${isCollapsed && "collapsed"}`}>
          <Link
            to="/dashboard"
            className={`menuBox ${
              location.pathname.includes("/user-management") || isDashboardPage
                ? "active"
                : ""
            }`}
            onClick={() => setIsDashboardPage(true)}
          >
            <DashboardMenuIcon
              color={
                isCollapsed
                  ? "#fff"
                  : location.pathname.includes("/user-management")
                  ? "#000"
                  : !isDashboardPage
                  ? "#fff"
                  : "#000"
              }
            />
            <span>Dashboard</span>
          </Link>
          <Link
            to="/dashboard/sales-management"
            className={`menuBox ${
              location.pathname === "/dashboard/sales-management"
                ? "active"
                : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <AddPaymentMenuIcon
              color={
                location.pathname === "/dashboard/sales-management" &&
                isCollapsed
                  ? "#fff"
                  : location.pathname === "/dashboard/sales-management"
                  ? "#000"
                  : "#fff"
              }
            />
            <span>Add Zimidar Payment</span>
          </Link>
          <Link
            to="/dashboard/payment-management"
            className={`menuBox ${
              location.pathname === "/dashboard/payment-management"
                ? "active"
                : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <ViewPaymentMenuIcon
              color={
                location.pathname === "/dashboard/payment-management" &&
                isCollapsed
                  ? "#fff"
                  : location.pathname === "/dashboard/payment-management"
                  ? "#000"
                  : "#fff"
              }
            />
            <span>View Payment</span>
          </Link>
          <Link
            to="/dashboard/sales"
            className={`menuBox ${
              location.pathname === "/dashboard/sales" ||
              location.pathname.includes("/edit-sale/")
                ? "active"
                : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <SaleMenuIcon
              color={
                isCollapsed
                  ? "#fff"
                  : location.pathname === "/dashboard/sales" ||
                    location.pathname.includes("/edit-sale")
                  ? "#000"
                  : "#fff"
              }
            />
            <span>Sale</span>
          </Link>
          <Link
            to="/dashboard/update-balances"
            className={`menuBox ${
              location.pathname === "/dashboard/update-balances" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <UpdateBalanceMenuIcon
              color={
                location.pathname === "/dashboard/update-balances" &&
                isCollapsed
                  ? "#fff"
                  : location.pathname === "/dashboard/update-balances"
                  ? "#000"
                  : "#fff"
              }
            />
            <span>Update Balances</span>
          </Link>
          <Link
            to="/dashboard/balance-sheet"
            className={`menuBox ${
              location.pathname === "/dashboard/balance-sheet" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <BalanceSheetMenuIcon
              color={
                location.pathname === "/dashboard/balance-sheet" && isCollapsed
                  ? "#fff"
                  : location.pathname === "/dashboard/balance-sheet"
                  ? "#000"
                  : "#fff"
              }
            />
            <span>Balance Sheet</span>
          </Link>
          <Link
            to="/dashboard/reports"
            className={`menuBox ${
              location.pathname === "/dashboard/reports" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <ReportsMenuIcon
              color={
                location.pathname === "/dashboard/reports" && isCollapsed
                  ? "#fff"
                  : location.pathname === "/dashboard/reports"
                  ? "#000"
                  : "#fff"
              }
            />
            <span>Reports</span>
          </Link>
        </div>

        <div className={`ProfileMenu menuItems  ${isCollapsed && "collapsed"}`}>
          <Link
            to="/dashboard/admin"
            className={`menuBox ${
              location.pathname === "/dashboard/admin" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <img
              src={image || defaultProfileImg}
              className="img-fluid ProfileImg"
              alt="Profile-Img"
            />
            <span>{username ? <p>{username}</p> : <p>Loading...</p>}</span>
          </Link>
        </div>
      </div>
      <MobileSideBar />
    </>
  );
}

export default SideBar;

function MobileSideBar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isDashboardPage, setIsDashboardPage] = useState(true);
  const { username, image } = useSelector((state) => state.auth);
  const location = useLocation();
  const defaultProfileImg = "https://placehold.co/600x400?text=Admin";

  useEffect(() => {
    // Check if the current URL is exactly "/dashboard"
    if (location.pathname !== "/dashboard") {
      setIsDashboardPage(false);
    } else {
      setIsDashboardPage(true);
    }
  }, [location.pathname]);

  return (
    <>
      <div className="mobileSidebarContainer">
        <button className="toggleBtn" onClick={() => setIsCollapsed(true)}>
          <ToggleIcon />
        </button>
        <div className="siteLogo">
          <div className="mainLogo">Fresh Fruit</div>
        </div>
        <div className="ProfileLogo">
          <img src={image || defaultProfileImg} alt="Profile" />
        </div>
      </div>
      <div className={`mobileMenuModal ${!isCollapsed && "collapsed"}`}>
        <div className="backToggleIcon" onClick={() => setIsCollapsed(false)}>
          <BackIcon /> Back
        </div>
        <div className={`menuItems  ${isCollapsed && "collapsed"}`}>
          <Link
            to="/dashboard"
            className={`menuBox ${
              location.pathname === "/user-management" || isDashboardPage
                ? "active"
                : ""
            }`}
            onClick={() => {
              setIsDashboardPage(true);
              setIsCollapsed(false);
            }}
          >
            <DashboardMenuIcon
              color={
                location.pathname === "/user-management" || isDashboardPage
                  ? "#fff"
                  : "#000"
              }
            />
            <span>Dashboard</span>
          </Link>
          <Link
            to="/dashboard/sales-management"
            className={`menuBox ${
              location.pathname === "/dashboard/sales-management"
                ? "active"
                : ""
            }`}
            onClick={() => {
              setIsDashboardPage(false);
              setIsCollapsed(false);
            }}
          >
            <AddPaymentMenuIcon
              color={
                location.pathname === "/dashboard/sales-management"
                  ? "#fff"
                  : "#000"
              }
            />
            <span>Add Zimidar Payment</span>
          </Link>
          <Link
            to="/dashboard/payment-management"
            className={`menuBox ${
              location.pathname === "/dashboard/payment-management"
                ? "active"
                : ""
            }`}
            onClick={() => {
              setIsDashboardPage(false);
              setIsCollapsed(false);
            }}
          >
            <ViewPaymentMenuIcon
              color={
                location.pathname === "/dashboard/payment-management"
                  ? "#fff"
                  : "#000"
              }
            />
            <span>View Payment</span>
          </Link>
          <Link
            to="/dashboard/sales"
            className={`menuBox ${
              location.pathname === "/dashboard/sales" ||
              location.pathname.includes("/edit-sale/")
                ? "active"
                : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <SaleMenuIcon
              color={
                location.pathname.includes("/sales") ||
                location.pathname === "/dashboard/sale" ||
                location.pathname.includes("/edit-sale")
                  ? "#fff"
                  : "#000"
              }
            />
            <span>Sale</span>
          </Link>
          <Link
            to="/dashboard/update-balances"
            className={`menuBox ${
              location.pathname === "/dashboard/update-balances" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <UpdateBalanceMenuIcon
              color={
                location.pathname === "/dashboard/update-balances"
                  ? "#fff"
                  : "#000"
              }
            />
            <span>Update Balances</span>
          </Link>
          <Link
            to="/dashboard/balance-sheet"
            className={`menuBox ${
              location.pathname === "/dashboard/balance-sheet" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <BalanceSheetMenuIcon
              color={
                location.pathname === "/dashboard/balance-sheet"
                  ? "#fff"
                  : "#000"
              }
            />
            <span>Balance Sheet</span>
          </Link>
          <Link
            to="/dashboard/reports"
            className={`menuBox ${
              location.pathname === "/dashboard/reports" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <ReportsMenuIcon
              color={
                location.pathname === "/dashboard/reports" ? "#fff" : "#000"
              }
            />
            <span>Reports</span>
          </Link>
        </div>

        <div className={`ProfileMenu menuItems  ${isCollapsed && "collapsed"}`}>
          <Link
            to="/dashboard/admin"
            className={`menuBox ${
              location.pathname === "/dashboard/admin" ? "active" : ""
            }`}
            onClick={() => setIsDashboardPage(false)}
          >
            <img
              src={image || defaultProfileImg}
              className="img-fluid ProfileImg"
              alt="Profile-Img"
            />
            <span>{username ? <p>{username}</p> : <p>Loading...</p>}</span>
          </Link>
        </div>
      </div>
    </>
  );
}
